/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./color-config.vue?vue&type=template&id=21f461cd&scoped=true&"
import script from "./color-config.vue?vue&type=script&lang=js&"
export * from "./color-config.vue?vue&type=script&lang=js&"
import style0 from "./color-config.vue?vue&type=style&index=0&id=21f461cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f461cd",
  null
  
)

export default component.exports